<template>
  <div class="container">
    <slot></slot>
    <label ref="label">{{ type }}</label>
  </div>
</template>

<script>
import anime from "animejs/lib/anime.es.js";
export default {
  name: "InputSlot",
  props: {
    type: {
      type: String,
      required: true,
    },
    func: {
      type: String,
      required: true,
    },
  },
  methods: {
    animate() {
      let el = document.getElementsByClassName(this.type);
      el[0].addEventListener("focus", () => {
        if (this.func === "")
          anime({
            targets: this.$refs.label,
            translateY: -8,
            fontSize: ["17px", "12px"],
          });
      });
      el[0].addEventListener("blur", () => {
        if (this.func === "")
          anime({
            targets: this.$refs.label,
            translateY: 0,
            fontSize: ["12px", "17px"],
          });
      });
    },
  },
  mounted() {
    this.animate();
  },
};
</script>

<style scoped>
.container {
  position: relative;
}
label {
  color: #f6f4f2;
  font-size: 17px;
  font-weight: 400;
  position: absolute;
  pointer-events: none;
  left: 16px;
  top: 28px;
}

input,
textarea {
  background: none;
  background-color: var(--dark);
  color: #f6f4f2;
  font-size: 17px;
  line-height: 1.23543;
  font-weight: 400;
  letter-spacing: -0.022em;
  padding-top: 18px;
  padding-left: 16px;
  padding-right: 16px;
  display: block;
  width: 100%;
  border: none;
  border-radius: 4px;
  border: 1px solid var(--light);
  margin: 12px 0px;
  width: 460px;
  height: 56px;
  font-family: "RoobertTRIAL-Regular";
}
input,
textarea:focus {
  outline: none;
}
.height {
  height: 112px;
  padding-top: 26px;
  resize: vertical;
  min-height: 112px;
}
</style>
